var VISIBLE_SLIDES_BREAKPOINT_1 = 1.1;
var VISIBLE_SLIDES_BREAKPOINT_2 = 2.1;
var CAROUSEL_BREAKPOINT_1 = 768;
var CAROUSEL_BREAKPOINT_2 = 1024;
var MEDIA_QUERY_MATCH = "(max-width: ".concat(CAROUSEL_BREAKPOINT_2, "px) and (min-width: ").concat(CAROUSEL_BREAKPOINT_1, "px)");
export { VISIBLE_SLIDES_BREAKPOINT_1, VISIBLE_SLIDES_BREAKPOINT_2, CAROUSEL_BREAKPOINT_1, CAROUSEL_BREAKPOINT_2, MEDIA_QUERY_MATCH };